import AOS from 'aos'
import 'aos/dist/aos.css'

export function installAOS() {
  AOS.init({
    // Disable horizontal animations on mobile to prevent scroll issues
    disable: false,
    // Only animate once when scrolling down
    once: true,
    // Reduce animation offset to prevent overflow
    offset: 50,
    // Shorter duration for smoother experience
    duration: 600,
    // Add custom easing
    easing: 'ease-in-out',
  })
}
